import styled from 'styled-components';
import theme from '../../../assets/styles/theme';
import { Span } from '../../Texts/Span/Span.styles';

export const CardNumber = styled.div`
  display: flex;
  justify-content: 'flex-start';
`;

export const CardNumberSpan = styled(Span)`
  margin-right: ${theme.spacing['spacing-3']};
`;
